<div class="jumbotron">
  <div class="">
    <h1 class="jumbotron-title">PLANTS Database</h1>
    <h2 class="jumbotron-subtitle">Plant List of Attributes, Names, Taxonomy, and Symbols</h2>
    <plant-quick-find></plant-quick-find>
    <p class="jumbotron-text usa-prose margin-top-1">
      The PLANTS Database provides standardized information about the vascular plants, mosses,
      liverworts, hornworts, and lichens of the United States and its territories. It includes
      names, plant symbols, checklists, distributional data, species abstracts, characteristics,
      images, crop information, automated tools, web links, and references.
    </p>
  </div>
  <div class="spotlight">
    <img class="spotlight-photo" src="{{ this.imageUrl() }}" alt="{{ this.altImageText() }}" />
    <h2 class="spotlight-title">{{ this.commonName() }}</h2>
    <p>
      <span>{{ this.scientificName() }}</span>
    </p>
    <button class="usa-button" (click)="onRouteToProfile()">View Profile</button>
  </div>
</div>
